import { render, staticRenderFns } from "./PluginCom.vue?vue&type=template&id=17863708"
import script from "./PluginCom.vue?vue&type=script&lang=js"
export * from "./PluginCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17863708')) {
      api.createRecord('17863708', component.options)
    } else {
      api.reload('17863708', component.options)
    }
    module.hot.accept("./PluginCom.vue?vue&type=template&id=17863708", function () {
      api.rerender('17863708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/plugin/PluginCom.vue"
export default component.exports